.spinner {
  display: inline-block;
  width: var(--size-icon);
  height: var(--size-icon);
  flex-shrink: 0;
  border-radius: var(--radius-full);
  border: 2px solid currentColor;
  border-right-color: transparent;
  animation: orthos-spin 0.7s linear infinite;
}
